import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getSiteConfig } from '../services/api';
import { FaFacebook, FaInstagram, FaTiktok, FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt, FaLinkedin } from 'react-icons/fa';

function Footer() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    getSiteConfig().then(res => setConfig(res.data)).catch(err => console.error(err));
  }, []);

  return (
    <footer className="bg-white border-t border-yellow-600">
      <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h2 className="text-yellow-500 text-2xl font-bold tracking-widest uppercase mb-4">Royal Cars</h2>
        <p className="text-gray-400 text-sm leading-relaxed">
        {config?.footerDescription || 'Votre spécialiste en véhicules de qualité.'}
        </p>
        </div>
<div>
  <h3 className="text-yellow-500 font-bold mb-4 uppercase tracking-wider">Liens rapides</h3>
  <ul className="flex flex-col gap-2">
    <li><Link to="/" className="text-gray-500 hover:text-yellow-500 transition text-sm">Accueil</Link></li>
    <li><Link to="/vehicules-neufs" className="text-gray-500 hover:text-yellow-500 transition text-sm">Véhicules neufs</Link></li>
    <li><Link to="/vehicules-occasion" className="text-gray-500 hover:text-yellow-500 transition text-sm">Véhicules occasion</Link></li>
    <li><Link to="/promotions" className="text-gray-500 hover:text-yellow-500 transition text-sm">Promotions</Link></li>
    <li><Link to="/vendus" className="text-gray-500 hover:text-yellow-500 transition text-sm">Véhicules vendus</Link></li>
    <li><Link to="/about" className="text-gray-500 hover:text-yellow-500 transition text-sm">Qui sommes-nous</Link></li>
  </ul>
</div>
        <div>
          <h3 className="text-yellow-500 font-bold mb-4 uppercase tracking-wider">Contact</h3>
          <ul className="flex flex-col gap-2 text-gray-500 text-sm">
        {config?.phone && (
        <li>
            <a href={"tel:" + config.phone} className="flex items-center gap-2 hover:text-yellow-500 transition">
            <FaPhone size={14} /> {config.phone}
            </a>
        </li>
        )}
        {config?.email && (
        <li>
            <a href={"mailto:" + config.email} className="flex items-center gap-2 hover:text-yellow-500 transition">
            <FaEnvelope size={14} /> {config.email}
            </a>
        </li>
        )}
        {config?.address && (
        <li className="flex items-center gap-2">
            <FaMapMarkerAlt size={14} /> {config.address}
        </li>
        )}
          </ul>
        </div>
        <div>
          <h3 className="text-yellow-500 font-bold mb-4 uppercase tracking-wider">Reseaux sociaux</h3>
          <ul className="flex flex-col gap-2 text-gray-500 text-sm">
        {config?.facebook && (
        <li>
            <a href={config.facebook} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-yellow-500 transition">
            <FaFacebook size={16} /> Facebook
            </a>
        </li>
        )}
        {config?.instagram && (
        <li>
            <a href={config.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-yellow-500 transition">
            <FaInstagram size={16} /> Instagram
            </a>
        </li>
        )}
        {config?.tiktok && (
        <li>
            <a href={config.tiktok} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-yellow-500 transition">
            <FaTiktok size={16} /> TikTok
            </a>
        </li>
        )}
        {config?.whatsapp && (
        <li>
            <a href={"https://wa.me/" + config.whatsapp.replace(/\D/g, '')} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-yellow-500 transition">
            <FaWhatsapp size={16} /> WhatsApp
            </a>
        </li>
        )}
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-200/30 py-4">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-2">
        <p className="text-gray-600 text-sm">2025 Royal Cars. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;